import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../layout/service/user.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ImageModule } from 'primeng/image';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ProgressBarModule } from 'primeng/progressbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { ChartModule } from 'primeng/chart';
import { Router } from '@angular/router';
import { BlockUIModule } from 'primeng/blockui';
import { TabsModule } from 'primeng/tabs';


@Component({
    selector: 'app-answer',
    imports: [
        FormsModule,
        CommonModule,
        InputTextModule,
        ImageModule,
        ProgressSpinnerModule,
        ButtonModule,
        MessageModule,
        PdfViewerModule,
        ProgressBarModule,
        ConfirmDialogModule,
        ChartModule,
        BlockUIModule,
        TabsModule
    ],
    providers: [ConfirmationService],
    template: `
    <p-confirmdialog />
    <p-blockui [blocked]="blockedPanel" />
    <div id="Formanswer" class="grid grid-cols-1 md:grid-cols-12 gap-6 w-full" *ngIf="!isFinished">
        <div class="md:col-span-8 col-span-1">
            <div class="flex justify-between">
                <h3 class="font-bold">Soal {{ currentQuestionIndex + 1 }} dari {{ formDetailLength || 1 }}</h3>
                <div class="flex gap-2">
                    <p-button
                        severity="secondary"
                        variant="text"
                        label="Soal Sebelumnya"
                        icon="pi pi-step-backward"
                        [raised]="true"
                        [disabled]="currentQuestionIndex === 0"
                        (click)="onPreviousQuestion()" />
                    <p-button
                        severity="success"
                        variant="text"
                        label="Soal Berikutnya"
                        icon="pi pi-step-forward"
                        [raised]="true"
                        (click)="onNextQuestion()" />
                </div>
            </div>
            <p-progressbar [value]="getProgressValue()" [showValue]="true" [unit]="'%'" class="mb-4" />
            <p-tabs [(value)]="activeTabIndex" *ngIf="tabs.length > 0">
                <p-tablist>
                    <ng-container *ngFor="let tab of tabs; let i = index">
                        <p-tab [value]="i">{{ tab.category }}</p-tab>
                    </ng-container>
                </p-tablist>
                <p-tabpanels>
                    <ng-container *ngFor="let tab of tabs; let i = index">
                        <p-tabpanel [value]="i">
                            <!-- Description -->
                            <div class="mb-3 max-w-full break-normal whitespace-pre-line" [innerHTML]="descriptionSanitized"></div>
                            <!-- Image per tab/category -->
                            <div class="mb-3 flex-1 flex flex-col">
                                <ng-container *ngIf="getTabImage(tab, i) === 'loading'">
                                    <div class="flex flex-col items-center justify-center py-4 h-full">
                                        <p class="mb-2 text-gray-500">Mohon tunggu, gambar sedang dimuat</p>
                                        <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="getTabImage(tab, i) && getTabImage(tab, i) !== 'loading'; else noImageTab">
                                    <div class="h-full flex items-center justify-center">
                                        <p-image [src]="getTabImage(tab, i)" [preview]="true" alt="Gambar" [style]="{'height':'100%','width':'100%','object-fit':'cover'}">
                                            <ng-template #indicator>
                                                <i class="pi pi-search"></i>
                                            </ng-template>
                                            <ng-template #image>
                                                <img [src]="getTabImage(tab, i)" alt="gambar" [style]="{'height':'100%','width':'100%','object-fit':'cover'}" />
                                            </ng-template>
                                            <ng-template #preview let-style="style" let-previewCallback="previewCallback">
                                                <img [src]="getTabImage(tab, i)" alt="gambar" [style]="style" (click)="previewCallback()" />
                                            </ng-template>
                                        </p-image>
                                    </div>
                                </ng-container>
                                <ng-template #noImageTab>
                                    <div class="text-gray-400 italic">Tidak ada gambar.</div>
                                </ng-template>
                            </div>
                            <!-- Input fields for this tab/category -->
                            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-5">
                                <div *ngFor="let ans of tab.answers; let ai = index" class="mb-3">
                                    <label class="block font-medium mb-1">{{ ans.field }}</label>
                                    <input type="text" pInputText [(ngModel)]="ans.userInput" class="w-full mb-5" placeholder="Jawaban Anda..." (ngModelChange)="saveUserState(formDetails[0], formDetails[0]._parsedAnswers)" />
                                    <div class="flex items-center gap-2 justify-center w-full mb-5">
                                        <p-button
                                            *ngIf="formDetails[0].showCorrect"
                                            severity="success"
                                            [variant]="ans.checked ? undefined : 'outlined'"
                                            [raised]="true"
                                            [loading]="ans.loading"
                                            [disabled]="!ans.userInput || ans.userInput.trim().length === 0"
                                            icon="pi pi-check"
                                            size="small"
                                            (click)="onCheckAnswer(formDetails[0]._parsedAnswers, getAnswerIndex(tab.category, ai), 'checked', formDetails[0])"
                                        ></p-button>
                                        <p-button
                                            *ngIf="formDetails[0].showCorrect"
                                            severity="danger"
                                            [variant]="ans.checkedWrong ? undefined : 'outlined'"
                                            [raised]="true"
                                            [loading]="ans.loading"
                                            [disabled]="!ans.userInput || ans.userInput.trim().length === 0"
                                            icon="pi pi-times"
                                            size="small"
                                            (click)="onCheckAnswer(formDetails[0]._parsedAnswers, getAnswerIndex(tab.category, ai), 'checkedWrong', formDetails[0])"
                                        ></p-button>
                                    </div>
                                    <p-message *ngIf="formDetails[0].showCorrect" severity="success">{{ ans.value }}</p-message>
                                </div>
                            </div>
                            <div class="flex justify-end mt-4 gap-2">
                                <ng-container *ngIf="isAllAnswered(formDetails[0]._parsedAnswers)">
                                    <p-button
                                        *ngIf="formDetails[0].showCorrect"
                                        label="Tandai Semua Benar"
                                        severity="success"
                                        icon="pi pi-check"
                                        (click)="markAll(formDetails[0]._parsedAnswers, formDetails[0], true)"
                                        [disabled]="!isAllAnswered(formDetails[0]._parsedAnswers)"
                                        class="mr-2"
                                    ></p-button>
                                    <p-button
                                        *ngIf="formDetails[0].showCorrect"
                                        label="Tandai Semua Salah"
                                        severity="danger"
                                        icon="pi pi-times"
                                        (click)="markAll(formDetails[0]._parsedAnswers, formDetails[0], false)"
                                        [disabled]="!isAllAnswered(formDetails[0]._parsedAnswers)"
                                    ></p-button>
                                </ng-container>
                                <p-button
                                    *ngIf="!formDetails[0].showCorrect"
                                    [severity]="!isAllAnsweredPerTab(formDetails[0]._parsedAnswers) ? 'secondary' : 'success'"
                                    [disabled]="!isAllAnsweredPerTab(formDetails[0]._parsedAnswers)"
                                    (click)="formDetails[0].showCorrect = true; saveUserState(formDetails[0], formDetails[0]._parsedAnswers)"
                                    type="button"
                                    label="Tampilkan Jawaban Benar"
                                ></p-button>
                                <p-button
                                    *ngIf="formDetails[0].showCorrect && isAllMarked(formDetails[0]._parsedAnswers) && (questionHistoryList.length < formDetailLength)"
                                    severity="info"
                                    label="Soal Berikutnya"
                                    icon="pi pi-step-forward"
                                    (click)="onNextQuestion()"
                                ></p-button>
                                <p-button
                                    *ngIf="formDetails[0].showCorrect && isAllMarked(formDetails[0]._parsedAnswers) && (questionHistoryList.length >= formDetailLength)"
                                    severity="success"
                                    label="Selesai"
                                    icon="pi pi-check"
                                    (click)="onFinishQuestion($event)"
                                ></p-button>
                            </div>
                            <hr>
                            <!-- Penjelasan PDF dipindahkan ke luar tab -->
                        </p-tabpanel>
                    </ng-container>
                </p-tabpanels>
            </p-tabs>
            <!-- PDF Viewer: hanya dirender sekali per soal, di luar tab -->
            <div class="flex flex-col md:flex-row justify-between items-start md:items-center mt-6">
                <div class="w-full">
                    <div *ngIf="formDetails.length && formDetails[0].showCorrect">
                        <h3>Penjelasan</h3>
                        <pdf-viewer
                            [src]="detailExplanation"
                            [render-text]="true"
                            [original-size]="false"
                            style="width: 100%; height: 500px"
                        ></pdf-viewer>
                    </div>
                </div>
            </div>
        </div>
        <div class="md:col-span-4 col-span-1">
            <div class="mb-6">
                <div class="rounded-2xl shadow-lg bg-gradient-to-br from-blue-50 via-cyan-50 to-white border border-blue-100 p-6">
                    <div class="flex items-center gap-3 mb-4">
                        <span class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 text-blue-600 shadow">
                            <i class="pi pi-history text-xl"></i>
                        </span>
                        <div>
                            <h3 class="text-lg font-bold text-blue-700 mb-0">Riwayat Soal</h3>
                            <span class="text-xs text-gray-500">Total: {{ questionHistoryList.length }}</span>
                        </div>
                    </div>
                    <div class="flex flex-wrap gap-2">
                        <ng-container *ngFor="let q of questionHistoryList; let idx = index">
                            <button
                                class="w-10 h-10 rounded-xl border border-blue-300 flex items-center justify-center font-bold transition-all duration-150 shadow-sm"
                                [ngClass]="{
                                    'bg-gradient-to-br from-blue-500 to-cyan-500 text-white scale-110 shadow-lg': idx === currentQuestionIndex,
                                    'bg-white text-blue-700 hover:bg-blue-50': idx !== currentQuestionIndex
                                }"
                                (click)="goToHistory(idx)"
                                type="button"
                            >
                                {{ idx + 1 }}
                            </button>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="mb-6">
                <div class="rounded-2xl shadow-lg bg-gradient-to-br from-cyan-50 via-blue-50 to-white border border-cyan-100 p-6">
                    <div class="flex items-center gap-3 mb-2">
                        <span class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-cyan-100 text-cyan-600 shadow">
                            <i class="pi pi-tags text-xl"></i>
                        </span>
                        <div>
                            <h3 class="text-lg font-bold text-cyan-700 mb-0">Kategori</h3>
                        </div>
                    </div>
                    <div class="text-base font-semibold text-cyan-800 mt-2">
                        {{ selectedCase?.name || 'Tidak ada kategori' }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card" *ngIf="isFinished">
        <div class="flex flex-col items-center justify-center">
            <h2 class="text-2xl font-bold text-green-700 mb-2">Ringkasan Kuis</h2>
            <p class="text-gray-600 mb-6">Selamat! Berikut adalah ringkasan jawaban Anda.</p>
            <div class="w-full">
                <p-chart type="bar" [data]="data" [options]="options" class="h-[30rem]" />
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                    <div *ngFor="let catChart of categoryCharts">
                        <h4 class="font-bold text-cyan-700 mb-2">Detail Kategori: {{ catChart.category }}</h4>
                        <p-chart type="bar" [data]="catChart.data" [options]="catChart.options" class="h-[20rem]" />
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-5">
                    <div *ngFor="let item of summaryData; let i = index" class="bg-white rounded-lg shadow-md p-5 border border-gray-100 hover:shadow-lg transition-shadow">
                        <div class="flex items-center justify-between mb-2">
                            <span class="font-semibold text-blue-700">Soal: {{ i + 1 }}</span>
                            <span class="px-3 py-1 rounded-full text-xs font-bold"
                                [ngClass]="{
                                    'bg-green-100 text-green-700': item.score == 100,
                                    'bg-yellow-100 text-yellow-700': item.score > 0 && item.score < 100,
                                    'bg-red-100 text-red-700': item.score == 0
                                }">
                                Nilai: {{ item.score }}
                            </span>
                        </div>
                        <div class="mb-2">
                            <div class="text-sm text-gray-500 mb-1">Jawaban Anda:</div>
                            <div class="overflow-x-auto">
                                <!-- Group by category -->
                                <ng-container *ngFor="let group of groupByCategory(parseAnswer(item.answer))">
                                    <div class="font-semibold text-cyan-700 mt-2 mb-1">{{ group.category }}</div>
                                    <table class="min-w-full border border-gray-200 rounded-lg shadow-sm bg-gray-50 mb-4">
                                        <thead>
                                            <tr>
                                                <th class="px-2 py-1 border-b font-semibold text-left text-xs bg-blue-50 text-blue-700">Kolom</th>
                                                <th class="px-2 py-1 border-b font-semibold text-left text-xs bg-blue-50 text-blue-700">Kunci Jawaban</th>
                                                <th class="px-2 py-1 border-b font-semibold text-left text-xs bg-blue-50 text-blue-700">Jawaban Anda</th>
                                                <th class="px-2 py-1 border-b font-semibold text-left text-xs bg-blue-50 text-blue-700">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let ans of group.answers" [ngClass]="{'bg-green-50': ans.checked, 'bg-red-50': ans.checkedWrong}">
                                                <td class="px-2 py-1 border-b text-xs">{{ ans.field }}</td>
                                                <td class="px-2 py-1 border-b text-xs">{{ ans.value }}</td>
                                                <td class="px-2 py-1 border-b text-xs">{{ ans.userInput }}</td>
                                                <td class="px-2 py-1 border-b text-xs">
                                                    <span *ngIf="ans.checked" class="text-green-600 font-bold">Benar</span>
                                                    <span *ngIf="ans.checkedWrong" class="text-red-600 font-bold">Salah</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex gap-2 justify-center mt-8">
                    <p-button
                        label="Ulangi Kuis"
                        icon="pi pi-refresh"
                        severity="warn"
                        (click)="repeatQuiz()"
                    ></p-button>
                    <p-button
                        label="Kembali ke Beranda"
                        icon="pi pi-home"
                        severity="secondary"
                        (click)="backToHome()"
                    ></p-button>
                </div>
            </div>
        </div>
    </div>
    `
})
export class Answer implements OnInit {
    formDetails: any[] = [];
    formDetailLength: number = 0;
    page: number = 1;
    exluded_ids: number[] = [];
    detailExplanation: string = '';
    explanationCache: { [id: number]: string } = {};
    imageCache: { [id: number]: string | null } = {};
    questionHistory: number = 0;
    questionHistoryList: any[] = [];
    currentQuestionIndex: number = 0;
    selectedCase: any = null;

    userId: string = '';

    isFinished: boolean = false;
    summaryData: any[] = [];
    data: any;
    options: any;

    blockedPanel: boolean = false;

    tabs: { category: string, answers: any[] }[] = [];
    activeTabIndex: number = 0;

    // Map untuk menyimpan image per kategori/tab
    tabImages: { [category: string]: string | 'loading' | null } = {};

    // Tambahkan property di dalam class Answer:
    categoryCharts: { category: string, data: any, options: any }[] = [];

    constructor(
        private userService: UserService,
        private confirmationService: ConfirmationService,
        private router: Router
    ) { }

    ngOnInit(): void {

        const storedIds = localStorage.getItem('excluded_form_detail_ids');
        if (storedIds) {
            this.exluded_ids = JSON.parse(storedIds);
        }
        const historyList = localStorage.getItem('question_history_list');
        if (historyList) {
            this.questionHistoryList = JSON.parse(historyList);
        }
        this.currentQuestionIndex = Number(localStorage.getItem('current_question_index')) || 0;
        const user = localStorage.getItem('user');
        if (user) {
            try {
                this.userId = JSON.parse(user).ID_USER || '';
            } catch {
                this.userId = '';
            }
        }
        this.isFinished = localStorage.getItem('isFinished') === 'true';
        if (this.isFinished) {
            this.finishAndShowSummary();
        }
        this.initApi();
    }

    async initApi(): Promise<void> {
        const selectedCaseString = localStorage.getItem('selected_case');
        const selectedCase = selectedCaseString ? JSON.parse(selectedCaseString) : null;
        this.selectedCase = selectedCase;
        // Only fetch formDetailLength once per session
        if (this.formDetailLength == 0) {
            try {
                const res = await this.userService.getFormDetails(selectedCase.id);
                this.formDetailLength = res.data.length;
            } catch {}
        }

        if (this.isFinished) {
            const payload = {
                user_id: this.userId,
                case_id: selectedCase?.id
            };
            this.userService.getFormDetailsAnswer(payload)
                .then((res: any) => {
                    this.summaryData = Array.isArray(res.data) ? res.data : [];
                    if (this.formDetailLength == this.summaryData.length) {
                        this.finishAndShowSummary();
                    }
                    this.prepareChartData();
                })
                .catch((err: any) => {
                    console.error('Gagal mengambil jawaban:', err);
                    this.summaryData = [];
                    this.prepareChartData();
                });
            return;
        }

        // Restore history and state
        const lastDetailId = localStorage.getItem('last_form_detail_id');
        if (lastDetailId) {
            const lastDetailData = localStorage.getItem('last_form_detail_data');
            const lastUserState = localStorage.getItem('last_form_detail_user_state');
            if (lastDetailData) {
                const detailObj = JSON.parse(lastDetailData);
                if (!this.questionHistoryList.length || !this.questionHistoryList.find((q: any) => q.id === detailObj.id)) {
                    this.questionHistoryList.push(detailObj);
                    localStorage.setItem('question_history_list', JSON.stringify(this.questionHistoryList));
                }
                this.formDetails = [detailObj];
                this.currentQuestionIndex = this.questionHistoryList.findIndex(q => q.id === detailObj.id);
                localStorage.setItem('current_question_index', String(this.currentQuestionIndex));
                for (let detail of this.formDetails) {
                    let userState: any = {};
                    if (lastUserState) {
                        userState = JSON.parse(lastUserState);
                    }
                    // Flatten jika _parsedAnswers atau form berupa array kategori dengan property form
                    const flattenAnswers = (arr: any[]) => {
                        // Jika array berisi kategori dengan property form (array)
                        if (arr.length && arr[0].form && Array.isArray(arr[0].form)) {
                            // Gabungkan semua form dari setiap kategori menjadi satu array flat
                            return arr.flatMap((cat, catIdx) =>
                                cat.form.map((item: any, idx: number) => ({
                                    ...item,
                                    // Optionally, simpan info kategori jika perlu
                                    category: cat.name,
                                    userInput: userState.answers?.[catIdx * cat.form.length + idx]?.userInput || item.userInput || '',
                                    checked: userState.answers?.[catIdx * cat.form.length + idx]?.checked ?? item.checked ?? false,
                                    checkedWrong: userState.answers?.[catIdx * cat.form.length + idx]?.checkedWrong ?? item.checkedWrong ?? false
                                }))
                            );
                        }
                        // Jika sudah flat
                        return arr.map((ans: any, idx: number) => ({
                            ...ans,
                            userInput: userState.answers?.[idx]?.userInput || ans.userInput || '',
                            checked: userState.answers?.[idx]?.checked ?? ans.checked ?? false,
                            checkedWrong: userState.answers?.[idx]?.checkedWrong ?? ans.checkedWrong ?? false
                        }));
                    };

                    if (Array.isArray(detail._parsedAnswers)) {
                        detail._parsedAnswers = flattenAnswers(detail._parsedAnswers);
                    } else if (Array.isArray(detail.form)) {
                        detail._parsedAnswers = flattenAnswers(detail.form);
                    } else {
                        const parsed = this.parseAnswer(detail.answer);
                        detail._parsedAnswers = flattenAnswers(parsed);
                    }

                    // Tambahkan update tabs di sini
                    this.tabs = this.getTabsFromAnswers(detail._parsedAnswers);
                    this.activeTabIndex = 0;
                    this.tabImages = {}; // reset cache

                    detail.showCorrect = userState.showCorrect || false;
                    detail.imageLoading = true;
                    detail.imageUrl = null;
                    try {
                        const payload = {
                            form_detail_id: detail.id,
                            type: 'image'
                        };
                        const imgRes = await this.userService.getFormDetailsInfo(payload);
                        detail.imageUrl = imgRes.data.value;
                    } catch (e) {
                        detail.imageUrl = null;
                    }
                    detail.imageLoading = false;
                    if (detail.showCorrect || this.isAllAnswered(detail._parsedAnswers)) {
                        this.showExplanation(detail);
                    }
                }
                return;
            }
        }

        // Fetch next question only if needed
        await this.fetchAndSetNextQuestion(selectedCase.id);
    }

    private async fetchAndSetNextQuestion(caseId: number) {
        // Only fetch if not already in history
        const res = await this.userService.getFormDetails(caseId, 1, this.exluded_ids);
        this.formDetails = res.data;
        if (!this.formDetails.length) return;

        const detail = this.formDetails[0];
        // Update excluded_ids and history
        if (!this.exluded_ids.includes(detail.id)) {
            this.exluded_ids.push(detail.id);
            localStorage.setItem('excluded_form_detail_ids', JSON.stringify(this.exluded_ids));
        }
        if (!this.questionHistoryList.find((q: any) => q.id === detail.id)) {
            this.questionHistoryList.push(detail);
            localStorage.setItem('question_history_list', JSON.stringify(this.questionHistoryList));
        }
        this.currentQuestionIndex = this.questionHistoryList.length - 1;
        localStorage.setItem('current_question_index', String(this.currentQuestionIndex));
        localStorage.setItem('last_form_detail_id', detail.id);
        localStorage.setItem('last_form_detail_data', JSON.stringify(detail));

        // Prepare answer state
        // --- FLATTEN ANSWERS ---
        const flattenAnswers = (arr: any[]) => {
            if (arr.length && arr[0].form && Array.isArray(arr[0].form)) {
                return arr.flatMap((cat, catIdx) =>
                    cat.form.map((item: any, idx: number) => ({
                        ...item,
                        category: cat.name,
                        userInput: '',
                        checked: false,
                        checkedWrong: false
                    }))
                );
            }
            return arr.map((ans: any) => ({
                ...ans,
                userInput: '',
                checked: false,
                checkedWrong: false
            }));
        };
        let parsed = this.parseAnswer(detail.answer);
        detail._parsedAnswers = flattenAnswers(parsed);
        detail.showCorrect = false;

        // Update tabs setiap kali soal baru
        this.tabs = this.getTabsFromAnswers(detail._parsedAnswers);
        this.activeTabIndex = 0;
        this.tabImages = {}; // reset cache

        // Fetch image only if not cached
        await this.setImage(detail);

        // Fetch explanation only if needed (not here, but in showExplanation)
    }

    private async setImage(detail: any) {
        if (this.imageCache[detail.id] !== undefined) {
            detail.imageUrl = this.imageCache[detail.id];
            detail.imageLoading = false;
            return;
        }
        detail.imageLoading = true;
        try {
            const payload = { form_detail_id: detail.id, type: 'image' };
            const imgRes = await this.userService.getFormDetailsInfo(payload);
            detail.imageUrl = imgRes.data.value;
            this.imageCache[detail.id] = detail.imageUrl;
        } catch {
            detail.imageUrl = null;
            this.imageCache[detail.id] = null;
        }
        detail.imageLoading = false;
    }

    parseAnswer(answer: string): any[] {
        try {
            return JSON.parse(answer);
        } catch {
            return [];
        }
    }

    isAllAnswered(answers: any[]): boolean {
        return answers.every(ans => ans.userInput && ans.userInput.trim().length > 0);
    }

    // Mengecek hanya jawaban pada tab tertentu
    isAllAnsweredPerTab(tabAnswers: any[]): boolean {
        if (!Array.isArray(tabAnswers)) return false;
        return tabAnswers.length > 0 && tabAnswers.every(ans => ans.userInput && ans.userInput.trim().length > 0);
    }

    isAllMarked(answers: any[]): boolean {
        return answers.every(ans => ans.checked || ans.checkedWrong);
    }

    saveUserState(detail: any, answers: any[]) {
        const userState = {
            answers: answers.map(ans => ({
                userInput: ans.userInput,
                checked: ans.checked || false,
                checkedWrong: ans.checkedWrong || false
            })),
            showCorrect: detail.showCorrect || false
        };
        let userStates: { [id: string]: any } = {};
        const userStatesRaw = localStorage.getItem('question_user_states');
        if (userStatesRaw) {
            userStates = JSON.parse(userStatesRaw);
        }
        userStates[detail.id] = userState;
        localStorage.setItem('question_user_states', JSON.stringify(userStates));
        // Only call showExplanation if state changed from not all answered to all answered, or showCorrect just turned true
        const prevState = detail._lastShowExplanationState || { allAnswered: false, showCorrect: false };
        const nowAllAnswered = this.isAllAnswered(answers);
        const nowShowCorrect = detail.showCorrect || false;
        if ((!prevState.allAnswered && nowAllAnswered) || (!prevState.showCorrect && nowShowCorrect)) {
            this.showExplanation(detail);
        }
        detail._lastShowExplanationState = { allAnswered: nowAllAnswered, showCorrect: nowShowCorrect };
        localStorage.setItem('last_form_detail_user_state', JSON.stringify(userState));
    }

    async showExplanation(form: any) {
        // Use cache to avoid repeated fetch
        if (this.explanationCache[form.id]) {
            this.detailExplanation = this.explanationCache[form.id];
            return;
        }
        const payload = {
            form_detail_id: form.id,
            type: 'explanation'
        };
        try {
            const res = await this.userService.getFormDetailsInfo(payload);
            let explanation = JSON.parse(res.data.value);
            this.detailExplanation = explanation.data;
            this.explanationCache[form.id] = this.detailExplanation;
        } catch {
            this.detailExplanation = '';
        }
    }

    goToHistory(idx: number) {
        this.currentQuestionIndex = idx;
        localStorage.setItem('current_question_index', String(idx));
        const detail = this.questionHistoryList[idx];
        localStorage.setItem('last_form_detail_id', detail.id);
        localStorage.setItem('last_form_detail_data', JSON.stringify(detail));
        const userStatesRaw = localStorage.getItem('question_user_states');
        let userStates: { [id: string]: any } = {};
        if (userStatesRaw) {
            userStates = JSON.parse(userStatesRaw);
        }
        const userState = userStates[detail.id] || {};
        this.formDetails = [detail];
        for (const d of this.formDetails) {
            // Parse answers supporting both flat arrays and category-form structures
            const parsed = Array.isArray(d._parsedAnswers) && d._parsedAnswers.length ? d._parsedAnswers : this.parseAnswer(d.answer || JSON.stringify(d.form || []));
            const flattened = this.flattenAnswers(parsed);

            d._parsedAnswers = flattened.map((ans: any, aidx: number) => ({
                ...ans,
                userInput: userState.answers?.[aidx]?.userInput || ans.userInput || '',
                checked: userState.answers?.[aidx]?.checked ?? ans.checked ?? false,
                checkedWrong: userState.answers?.[aidx]?.checkedWrong ?? ans.checkedWrong ?? false
            }));

            d.showCorrect = d.showCorrect || false;
            // Update tabs saat pindah soal/history
            this.tabs = this.getTabsFromAnswers(d._parsedAnswers);
            this.activeTabIndex = 0;
            this.tabImages = {}; // reset cache
            // attempt to load image (async)
            this.setImage(d);
            if (d.showCorrect || this.isAllAnswered(d._parsedAnswers)) {
                this.showExplanation(d);
            }
        }
    }

    async onNextQuestion() {
        if (!this.formDetails.length) return;

        // If next question already exists in history, just navigate to it
        const nextIndex = Number(this.currentQuestionIndex) + 1;
        if (this.questionHistoryList && nextIndex < this.questionHistoryList.length) {
            this.goToHistory(nextIndex);
            return;
        }

        this.blockedPanel = true;
        const detail = this.formDetails[0];
        const answers = detail._parsedAnswers || [];
        const total = answers.length;
        const correct = answers.filter((a: any) => a.checked).length;
        const score = total > 0 ? Math.round((correct / total) * 100) : 0;

        const selectedCaseString = localStorage.getItem('selected_case');
        const selectedCase = selectedCaseString ? JSON.parse(selectedCaseString) : null;
        const case_id = selectedCase?.id;

        const payload = {
            form_detail_id: detail.id,
            user_id: this.userId,
            case_id: case_id,
            answer: JSON.stringify(answers),
            score: score
        };

        try {
            await this.userService.addFormDetailsAnswer(payload);
            // Fetch next question only if not finished
            if (this.questionHistoryList.length < this.formDetailLength) {
                await this.fetchAndSetNextQuestion(selectedCase.id);
            }
            // Always set currentQuestionIndex to last
            this.currentQuestionIndex = this.questionHistoryList.length - 1;
            localStorage.setItem('current_question_index', String(this.currentQuestionIndex));
        } catch (error) {
            console.error('Failed to save answer:', error);
        } finally {
            this.blockedPanel = false;
        }
    }

    onPreviousQuestion() {
        const newIndex = Number(this.currentQuestionIndex) - 1;
        if (newIndex >= 0 && this.questionHistoryList && this.questionHistoryList.length > newIndex) {
            // Mirror goToHistory logic here to ensure view updates reliably
            const idx = newIndex;
            this.currentQuestionIndex = idx;
            localStorage.setItem('current_question_index', String(idx));
            const detail = this.questionHistoryList[idx];
            localStorage.setItem('last_form_detail_id', detail.id);
            localStorage.setItem('last_form_detail_data', JSON.stringify(detail));

            const userStatesRaw = localStorage.getItem('question_user_states');
            let userStates: { [id: string]: any } = {};
            if (userStatesRaw) {
                try { userStates = JSON.parse(userStatesRaw); } catch { userStates = {}; }
            }
            const userState = userStates[detail.id] || {};

            this.formDetails = [detail];
            for (const d of this.formDetails) {
                const parsed = Array.isArray(d._parsedAnswers) && d._parsedAnswers.length ? d._parsedAnswers : this.parseAnswer(d.answer || JSON.stringify(d.form || []));
                const flattened = this.flattenAnswers(parsed);

                d._parsedAnswers = flattened.map((ans: any, aidx: number) => ({
                    ...ans,
                    userInput: userState.answers?.[aidx]?.userInput || ans.userInput || '',
                    checked: userState.answers?.[aidx]?.checked ?? ans.checked ?? false,
                    checkedWrong: userState.answers?.[aidx]?.checkedWrong ?? ans.checkedWrong ?? false
                }));

                d.showCorrect = d.showCorrect || false;
                // Update tabs saat pindah soal/history
                this.tabs = this.getTabsFromAnswers(d._parsedAnswers);
                this.activeTabIndex = 0;
                this.tabImages = {}; // reset cache
                // attempt to load image (async)
                this.setImage(d);
                if (d.showCorrect || this.isAllAnswered(d._parsedAnswers)) {
                    this.showExplanation(d);
                }
            }
        }
    }

    onCheckAnswer(answers: any[], idx: number, type: 'checked' | 'checkedWrong', detail: any) {
        if (type === 'checked') {
            answers[idx].checked = !answers[idx].checked;
            if (answers[idx].checked) {
                answers[idx].checkedWrong = false;
            }
        } else if (type === 'checkedWrong') {
            answers[idx].checkedWrong = !answers[idx].checkedWrong;
            if (answers[idx].checkedWrong) {
                answers[idx].checked = false;
            }
        }
        this.saveUserState(detail, answers);
    }

    markAll(answers: any[], detail: any, correct: boolean) {
        answers.forEach(ans => {
            ans.checked = correct;
            ans.checkedWrong = !correct;
        });
        this.saveUserState(detail, answers);
    }

    getProgressValue(): number {
        if (!this.formDetailLength) return 0;
        return Math.round((this.questionHistoryList.length / this.formDetailLength) * 100);
    }

    onFinishQuestion(event: Event) {
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Apakah Anda yakin ingin melanjutkan?',
            header: 'Konfirmasi',
            closable: true,
            closeOnEscape: true,
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: 'Batal',
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: 'Simpan',
            },
            accept: () => {
                if (this.formDetails.length) {
                    const detail = this.formDetails[0];
                    const answers = detail._parsedAnswers || [];
                    const total = answers.length;
                    const correct = answers.filter((a: any) => a.checked).length;
                    const score = total > 0 ? Math.round((correct / total) * 100) : 0;

                    const selectedCaseString = localStorage.getItem('selected_case');
                    const selectedCase = selectedCaseString ? JSON.parse(selectedCaseString) : null;
                    const case_id = selectedCase?.id;

                    const payload = {
                        form_detail_id: detail.id,
                        user_id: this.userId,
                        case_id: case_id,
                        answer: JSON.stringify(answers),
                        score: score
                    };

                    this.userService.addFormDetailsAnswer(payload)
                        .then(() => {
                            this.finishAndShowSummary();
                        })
                        .catch((err: any) => {
                            console.error('Gagal menyimpan jawaban terakhir:', err);
                            this.finishAndShowSummary();
                        });
                } else {
                    this.finishAndShowSummary();
                }
            },
            reject: () => {

            },
        });
    }

    finishAndShowSummary() {
        localStorage.removeItem('last_form_detail_id');
        localStorage.removeItem('last_form_detail_data');
        localStorage.removeItem('last_form_detail_user_state');
        localStorage.removeItem('excluded_form_detail_ids');
        localStorage.removeItem('question_history_list');
        localStorage.removeItem('current_question_index');
        localStorage.removeItem('question_user_states');
        localStorage.setItem('isFinished', 'true');
        this.isFinished = true;

        const selectedCaseString = localStorage.getItem('selected_case');
        const selectedCase = selectedCaseString ? JSON.parse(selectedCaseString) : null;
        const case_id = selectedCase?.id;

        const payload = {
            user_id: this.userId,
            case_id: case_id
        };
        this.userService.getFormDetailsAnswer(payload)
            .then((res: any) => {
                this.summaryData = Array.isArray(res.data) ? res.data : [];
                this.prepareChartData();
            })
            .catch((err: any) => {
                console.error('Gagal mengambil jawaban:', err);
                this.summaryData = [];
                this.prepareChartData();
            });
    }

    prepareChartData() {
        if (!this.summaryData.length) {
            this.data = undefined;
            this.categoryCharts = [];
            return;
        }

        // Group by category and count correct/wrong per category
        const categoryMap: { [cat: string]: { correct: number, wrong: number, answers: any[] } } = {};
        this.summaryData.forEach(item => {
            const answers = this.parseAnswer(item.answer);
            answers.forEach((ans: any) => {
                const cat = ans.category || 'Tanpa Kategori';
                if (!categoryMap[cat]) categoryMap[cat] = { correct: 0, wrong: 0, answers: [] };
                if (ans.checked) categoryMap[cat].correct++;
                if (ans.checkedWrong) categoryMap[cat].wrong++;
                categoryMap[cat].answers.push(ans);
            });
        });

        const categories = Object.keys(categoryMap);
        const correctCounts = categories.map(cat => categoryMap[cat].correct);
        const wrongCounts = categories.map(cat => categoryMap[cat].wrong);

        const documentStyle = getComputedStyle(document.documentElement);

        this.data = {
            labels: categories,
            datasets: [
                {
                    label: 'Benar',
                    backgroundColor: documentStyle.getPropertyValue('--p-green-300') || '#6ee7b7',
                    borderColor: documentStyle.getPropertyValue('--p-green-700') || '#047857',
                    data: correctCounts
                },
                {
                    label: 'Salah',
                    backgroundColor: documentStyle.getPropertyValue('--p-red-300') || '#fca5a5',
                    borderColor: documentStyle.getPropertyValue('--p-red-700') || '#b91c1c',
                    data: wrongCounts
                }
            ]
        };

        this.options = {
            responsive: true,
            plugins: {
                legend: {
                    labels: {
                        color: documentStyle.getPropertyValue('--text-color') || '#374151'
                    }
                },
                tooltip: {
                    callbacks: {
                        label: function(context: any) {
                            return `${context.dataset.label}: ${context.parsed.y}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: documentStyle.getPropertyValue('--text-color-secondary') || '#6b7280'
                    },
                    grid: {
                        color: documentStyle.getPropertyValue('--surface-border') || '#e5e7eb'
                    }
                },
                y: {
                    beginAtZero: true,
                    stacked: true,
                    ticks: {
                        color: documentStyle.getPropertyValue('--text-color-secondary') || '#6b7280'
                    },
                    grid: {
                        color: documentStyle.getPropertyValue('--surface-border') || '#e5e7eb'
                    }
                }
            }
        };

        // Tambahkan chart detail per kategori
        this.categoryCharts = categories.map(cat => {
            // Group by field in this category
            const fieldMap: { [field: string]: { correct: number, wrong: number } } = {};
            categoryMap[cat].answers.forEach(ans => {
                const field = ans.field || 'Tanpa Kolom';
                if (!fieldMap[field]) fieldMap[field] = { correct: 0, wrong: 0 };
                if (ans.checked) fieldMap[field].correct++;
                if (ans.checkedWrong) fieldMap[field].wrong++;
            });
            const fields = Object.keys(fieldMap);
            const corrects = fields.map(f => fieldMap[f].correct);
            const wrongs = fields.map(f => fieldMap[f].wrong);

            return {
                category: cat,
                data: {
                    labels: fields,
                    datasets: [
                        {
                            label: 'Benar',
                            backgroundColor: documentStyle.getPropertyValue('--p-green-300') || '#6ee7b7',
                            borderColor: documentStyle.getPropertyValue('--p-green-700') || '#047857',
                            data: corrects
                        },
                        {
                            label: 'Salah',
                            backgroundColor: documentStyle.getPropertyValue('--p-red-300') || '#fca5a5',
                            borderColor: documentStyle.getPropertyValue('--p-red-700') || '#b91c1c',
                            data: wrongs
                        }
                    ]
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            labels: {
                                color: documentStyle.getPropertyValue('--text-color') || '#374151'
                            }
                        },
                        tooltip: {
                            callbacks: {
                                label: function(context: any) {
                                    return `${context.dataset.label}: ${context.parsed.y}`;
                                }
                            }
                        }
                    },
                    scales: {
                        x: {
                            stacked: true,
                            ticks: {
                                color: documentStyle.getPropertyValue('--text-color-secondary') || '#6b7280'
                            },
                            grid: {
                                color: documentStyle.getPropertyValue('--surface-border') || '#e5e7eb'
                            }
                        },
                        y: {
                            beginAtZero: true,
                            stacked: true,
                            ticks: {
                                color: documentStyle.getPropertyValue('--text-color-secondary') || '#6b7280'
                            },
                            grid: {
                                color: documentStyle.getPropertyValue('--surface-border') || '#e5e7eb'
                            }
                        }
                    }
                }
            };
        });
    }

    repeatQuiz() {
        localStorage.removeItem('isFinished');
        this.isFinished = false;
        this.initApi();
    }

    backToHome() {
        localStorage.removeItem('selected_case');
        localStorage.removeItem('excluded_form_detail_ids');
        localStorage.removeItem('isFinished');
        this.router.navigate(['/app/dashboard']);
    }

    // Getter untuk deskripsi yang sudah di-replace &nbsp; menjadi spasi
    get descriptionSanitized() {
        return this.formDetails[0]?.description?.replace(/&nbsp;/g, ' ') || '';
    }

    // Group answers by category for tabbing
    getTabsFromAnswers(answers: any[]): { category: string, answers: any[] }[] {
        // Fix: preserve tab order based on image array if available, else fallback to answer order
        const detail = this.formDetails[0];
        let categories: string[] = [];
        if (detail && Array.isArray(detail.imageUrl)) {
            categories = detail.imageUrl
                .map((img: any) => typeof img.name === 'string' ? img.name.trim() : '')
                .filter((name: string) => !!name);
        } else {
            // fallback: unique categories from answers in order of appearance
            for (const ans of answers) {
                if (ans.category && !categories.includes(ans.category)) {
                    categories.push(ans.category);
                }
            }
        }
        // Group answers by category
        const group: { [cat: string]: any[] } = {};
        for (const ans of answers) {
            if (!group[ans.category]) group[ans.category] = [];
            group[ans.category].push(ans);
        }
        // Return in the order of categories
        return categories.map(category => ({
            category,
            answers: group[category] || []
        }));
    }

    // Helper to get index in flat _parsedAnswers array from tab/category and index in tab
    getAnswerIndex(category: string, idx: number): number {
        if (!this.formDetails.length) return idx;
        const answers = this.formDetails[0]._parsedAnswers;
        let count = -1;
        for (let i = 0; i < answers.length; i++) {
            if (answers[i].category === category) {
                count++;
                if (count === idx) return i;
            }
        }
        return idx;
    }

    getTabImage(tab: { category: string }, idx: number): string | 'loading' | null {
        const detail = this.formDetails[0];
        if (!detail) return null;

        // Jika masih loading
        if (detail.imageLoading) return 'loading';

        // Optimasi: hanya parse jika imageUrl adalah array JSON, jika tidak langsung return string
        try {
            if (typeof detail.imageUrl === 'string') {
                // Coba parse jika string berupa array JSON
                if (detail.imageUrl.trim().startsWith('[')) {
                    const imageArr = JSON.parse(detail.imageUrl);
                    if (Array.isArray(imageArr)) {
                        const imgObj = imageArr[idx];
                        if (!imgObj || !imgObj.image) return null;
                        const parsed = imgObj.image;
                        if (typeof parsed === 'string' && /^data:image\//.test(parsed)) {
                            return parsed;
                        }
                        if (parsed && typeof parsed.image === 'string') {
                            if (/^data:image\//.test(parsed.image)) {
                                return parsed.image;
                            }
                            return 'data:image/jpeg;base64,' + parsed.image;
                        }
                    }
                    return null;
                }
                // Jika imageUrl adalah satu string (single image)
                if (/^data:image\//.test(detail.imageUrl)) {
                    return detail.imageUrl;
                }
                // Jika string base64
                if (detail.imageUrl.length > 100) {
                    return 'data:image/jpeg;base64,' + detail.imageUrl;
                }
                return null;
            }
            // Jika imageUrl sudah array (jarang terjadi)
            if (Array.isArray(detail.imageUrl)) {
                const imgObj = detail.imageUrl[idx];
                if (!imgObj || !imgObj.image) return null;
                const parsed = imgObj.image;
                if (typeof parsed === 'string' && /^data:image\//.test(parsed)) {
                    return parsed;
                }
                if (parsed && typeof parsed.image === 'string') {
                    if (/^data:image\//.test(parsed.image)) {
                        return parsed.image;
                    }
                    return 'data:image/jpeg;base64,' + parsed.image;
                }
            }
        } catch (e) {
            // Hindari error berat di UI
            console.error('Gagal parse image JSON:', e);
            return null;
        }
        return null;
    }

    // Tambahkan method di dalam class Answer:
    groupByCategory(answers: any[]): { category: string, answers: any[] }[] {
        if (!Array.isArray(answers)) return [];
        const group: { [cat: string]: any[] } = {};
        for (const ans of answers) {
            const cat = ans.category || 'Tanpa Kategori';
            if (!group[cat]) group[cat] = [];
            group[cat].push(ans);
        }
        return Object.keys(group).map(category => ({
            category,
            answers: group[category]
        }));
    }

    // Flatten answers helper: handles both flat arrays and category-based arrays with `form` property
    flattenAnswers(arr: any[]): any[] {
        if (!Array.isArray(arr)) return [];
        // If array contains categories (each with `form` array), flatten them
        if (arr.length && arr[0] && Array.isArray(arr[0].form)) {
            return arr.flatMap((cat: any) => cat.form.map((f: any) => ({ ...f, category: cat.name || '' })));
        }
        // If elements already contain nested objects for categories inside elements, just return as-is
        return arr.map((a: any) => ({ ...a }));
    }

}
